module.exports = __webpack_public_path__ + "img/20.4-gallery.d25d193b.jpg";